import { useQuery } from "@tanstack/react-query";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { getAdminMe } from "@/services/adminApi";
import { routePaths } from "@/routes/routePaths";

export function RequireAdminAuth() {
  const location = useLocation();
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "me"],
    queryFn: getAdminMe,
    retry: false
  });

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center px-4 text-sm text-neutral-500">
        Checking admin session...
      </div>
    );
  }

  if (!data?.authenticated) {
    return <Navigate to={routePaths.admin.login} replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
